/**
 * Asynchronously loads the component for DocumentPage
 */

import * as React from 'react';
import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

export const ConciliationRequestViewPage = lazyLoad(
  () => import('./ViewPrefiller'),
  module => module.Prefiller,
  {
    fallback: <LoadingIndicator />,
  },
);
